import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {IMenuItem} from '@shared/interfaces/menu-item.interface';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {take} from 'rxjs/operators';
import {ContentScope} from '@shared/commands/command-base';
import {LiveSupportHistory} from '@features/xatbot/models/xat-bot-live-support.model';
import {LiveSupportService} from '@features/xatbot/services/live-support.service';

@Component({
    standalone: false,
    selector: 'particle-task-view-right-bar',
  templateUrl: './task-view-right-bar.component.html',
  styleUrls: ['./task-view-right-bar.component.scss']
})
export class TaskViewRightBarComponent implements OnInit {
  @Input() data: DialogModel;
  @Input() taskMenuItemsMapper:  any = {};
  @Output() selectedMenuChange$: EventEmitter<IMenuItem> = new EventEmitter();
  rightViewItems: any[] = [];
  dueDateReturnDetails: any;
  /** ITP-E-177-04 — the support ticket's connection history, read once to decide whether its section shows. */
  connectionHistory: LiveSupportHistory = null;
  constructor(private platformQueryService: PlatformQueryService,
              private liveSupportService: LiveSupportService) {
    this.rightViewItems = [
      {
        'title': 'Details',
        'id': 'TaskDetail',
        'editor': 'TaskDetailViewComponent'
      }
    ];
  }

  ngOnInit(): void {
    console.log('data from right bar component: ', this.data);
    if (this.data?.input?.card?.board?.name === 'Due Date Tracker') {
      this.fetchDueDateReturnDetails();
    }
    if (TaskViewRightBarComponent.isSupportTicket(this.data?.input?.card)) {
      this.fetchConnectionHistory();
    }
  }

  /** A ticket on the support board (Scope OrbitaxSupport): the only kind that can have live support sessions. */
  static isSupportTicket(card: any): boolean {
    return !!card?.id && (card.scope === 'ORBITAX_SUPPORT' || card.scopeInt === ContentScope.OrbitaxSupport
      || card.board?.scope === 'ORBITAX_SUPPORT' || card.board?.scopeInt === ContentScope.OrbitaxSupport);
  }

  /**
   * ITP-E-177-04 (story 14) — a support ticket that had a live support session gets a Connection history section. The server
   * decides who may read it (the ticket's access rule); a ticket with no session shows no section.
   */
  fetchConnectionHistory() {
    this.liveSupportService.history(this.data.input.card.id).pipe(take(1)).subscribe(history => {
      if (!history?.sessions?.length || this.rightViewItems.some(item => item.id === 'ConnectionHistory')) {
        return;
      }
      this.connectionHistory = history;
      this.rightViewItems.push({
        'title': 'Connection history',
        'id': 'ConnectionHistory',
        'editor': 'TaskConnectionHistoryComponent'
      });
    });
  }

  onSelectedMenuChanges($event: IMenuItem) {
    this.selectedMenuChange$.emit($event);
  }

  onClosePanel(item: any) {

  }

  onOpenPanel(item: any) {
   // console.log('open item:', item);
  }

  fetchDueDateReturnDetails() {
    const query = new PlatformQuery();
    query.api = Api.DueDateTracker;

    for (const obj of this.data.input.card.fieldValues) {
      query.fieldValues[obj.Key] = obj.Value;
    }

    // WHICH MODEL THIS FILING LIVES IN, off the ticket itself (DDT-E-61-15). The decomposed Due Date Tracker
    // stamps FilingSource = decomposed on the tickets it creates (DecomposedKanbanBridge); those filings have
    // no CompanyFilingModel, so the legacy query throws for them and this panel silently never appears. Every
    // other ticket carries no marker and keeps the query it has always used. The names are the API's
    // constants at the other end (DecomposedGlobalFilingForEmailQueryHandler).
    query.name = query.fieldValues['FilingSource'] === 'decomposed'
      ? 'DecomposedGlobalFilingForEmailQuery'
      : 'GlobalFilingForEmailQuery';

    query.fieldValues['TicketId'] = this.data.input.card.id;
    query.fieldValues['IncludeConsolidatedEntities'] = true;

    if (query.fieldValues.hasOwnProperty('FilingId') === false || query.fieldValues.hasOwnProperty('FieldKey') === false) { return; }

    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
        this.dueDateReturnDetails = response.fieldValues;
        console.log('due date return details: ', this.dueDateReturnDetails);
        this.rightViewItems.push(
          {
            'title': 'Return Details',
            'id': 'DueDateTaskReturnDetails',
            'editor': 'DueDateTaskReturnDetailsViewComponent'
          });
    });
  }
}
